import { Component, OnInit, ViewChild, Input, EventEmitter, Output } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Note } from '../../../models/Note';
import { NoteService } from '../../../services/note.service';
import { AuthorizeService } from '../../../../../api-authorization/authorize.service';

@Component({
  selector: 'app-note-form',
  templateUrl: './note-form.component.html'
})

export class NoteFormComponent implements OnInit {
  public userName: string;
  public userId: string;
  public editMode = false;

  //input/output parameters
  @Input() title;
  @Input() inputModel: Note;
  @Output() eventEmitter: EventEmitter<any> = new EventEmitter();

  public modelForm : FormGroup; 
  submitted = false;

  constructor(
    private formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private noteService: NoteService,
    private notification: MatSnackBar,
    private authorizeService: AuthorizeService
  ) { }

  // on component load
  ngOnInit() {
    // get current user
    this.authorizeService.getUser().subscribe(result => {
      this.userName = result.name;
      this.userId = result.sub;

      // allow only original creator to modify note.
      if (this.userName == this.inputModel.createdBy || this.inputModel.createdBy.length === 0) {
        this.editMode = true;
      }
    });
  
    this.modelForm = this.formBuilder.group({
      id: this.inputModel.id,
      contentId: [this.inputModel.contentId, Validators.required],
      contentType: [this.inputModel.contentType, Validators.required],
      description: [this.inputModel.description, [Validators.required, Validators.maxLength(500)]]
    });
  }

  // handle form submit 
  onSubmit() {
      this.submitted = true; 

      // stop here if form is invalid
    if (this.modelForm.invalid) {
        return; 
    }

    let formValues = this.modelForm.value as Note;

    // add
    if (formValues.id == 0) {
      this.noteService.add(formValues).subscribe(brandMonthConversion => {
        this.eventEmitter.emit(this.modelForm.value);
        this.activeModal.close(brandMonthConversion);
        this.showNotification(`The new note was successuly added!`, 'Okay!')
      });
      // update
    } else {
      this.noteService.update(formValues.id, formValues).subscribe(brandMonthConversion => {
        this.eventEmitter.emit(this.modelForm.value);
        this.activeModal.close(brandMonthConversion);
        this.showNotification(`The new note was successuly updated!`, 'Okay!')
      });
    }
  }

  // display notifications
  showNotification(msg: string, action: string) {
    this.notification.open(msg, action, { duration: 5000, panelClass: ['snackbar-success'] });
  }
}
